export default __webpack_public_path__ + "static/media/basic-pin-large-9.a396cd2e.png";